import {IssueTypePickerBase, type IssueType} from '@github-ui/item-picker/IssueTypePicker'
import {useIssueCreateDataContext} from './contexts/IssueCreateDataContext'
import {Suspense, useCallback} from 'react'
import {useIssueCreateConfigContext} from './contexts/IssueCreateConfigContext'
import {FormControl} from '@primer/react'
import {LABELS} from './constants/labels'
import type {PreloadedQuery} from 'react-relay'
import type {IssueTypePickerQuery} from '@github-ui/item-picker/IssueTypePickerQuery.graphql'

type IssueTypeSelectorProps = {
  issueTypesRef: PreloadedQuery<IssueTypePickerQuery>
}

export const IssueTypeSelector = ({issueTypesRef}: IssueTypeSelectorProps) => {
  const {issueType, setIssueType} = useIssueCreateDataContext()

  const {optionConfig} = useIssueCreateConfigContext()
  const sharedConfigProps = {
    insidePortal: optionConfig.insidePortal,
    shortcutEnabled: optionConfig.singleKeyShortcutsEnabled,
  }

  const setIssueTypeCallback = useCallback(
    (issueTypes: IssueType[] | null) => {
      setIssueType(issueTypes?.[0] || null)
    },
    [setIssueType],
  )

  return (
    <Suspense>
      <FormControl>
        <FormControl.Label as="span" id={LABELS.selectIssueTypeLabel}>
          {LABELS.typePickerLabel}
        </FormControl.Label>
        {/* using base and not picker to pass our own onSelectionChange */}
        <IssueTypePickerBase
          readonly={false}
          activeIssueType={issueType}
          issueTypeQueryRef={issueTypesRef}
          onSelectionChange={setIssueTypeCallback}
          ariaLabelledBy={LABELS.selectIssueTypeLabel}
          {...sharedConfigProps}
        />
      </FormControl>
    </Suspense>
  )
}

try{ IssueTypeSelector.displayName ||= 'IssueTypeSelector' } catch {}